"use strict";
/// <reference path="../../../../../Trillium.UI/TypeScript/Models/General/Helpers/TriStringList.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ChartsLegendsComponent = /** @class */ (function (_super) {
    __extends(ChartsLegendsComponent, _super);
    function ChartsLegendsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChartsLegendsComponent.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "chartsLegend" }, this.props.items.map(function (item, i) {
            return react_1.default.createElement("div", { className: "legendsSeriesSingle", key: i },
                react_1.default.createElement("div", { className: "legendsSeriesSquare square-" + i }),
                react_1.default.createElement("div", { className: "legendsSeriesText" }, item),
                react_1.default.createElement("div", { className: "clearfix" }));
        })));
    };
    return ChartsLegendsComponent;
}(react_1.default.Component));
exports.default = ChartsLegendsComponent;
